module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Statistics":"Statistiken","Campaigns":"Kampagnen","Meta Pixel":"Meta Pixel","Newsletters":"Newsletter","Subscription Topics":"Abonnement-Themen","Coupons":"Gutscheine"}}')
  delete Component.options._Ctor
}
